import api from '../..'

const destroyFolder = (folderId: number) => {
  return api.delete(`/administration/folders/${folderId}`)
}

export default destroyFolder
